"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class VirtualGatewayTlsValidationContextTrust {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayTlsValidationContextTrust = VirtualGatewayTlsValidationContextTrust;
class VirtualGatewayListenerTlsAcmCertificate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsAcmCertificate = VirtualGatewayListenerTlsAcmCertificate;
class VirtualGatewayTlsValidationContextFileTrust {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayTlsValidationContextFileTrust = VirtualGatewayTlsValidationContextFileTrust;
class VirtualGatewayHttp2ConnectionPool {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayHttp2ConnectionPool = VirtualGatewayHttp2ConnectionPool;
class VirtualGatewaySpec {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewaySpec = VirtualGatewaySpec;
class VirtualGatewayTlsValidationContext {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayTlsValidationContext = VirtualGatewayTlsValidationContext;
class VirtualGatewayListenerTlsCertificate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsCertificate = VirtualGatewayListenerTlsCertificate;
class VirtualGatewayGrpcConnectionPool {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayGrpcConnectionPool = VirtualGatewayGrpcConnectionPool;
class VirtualGatewayConnectionPool {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayConnectionPool = VirtualGatewayConnectionPool;
class SubjectAlternativeNames {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SubjectAlternativeNames = SubjectAlternativeNames;
class VirtualGatewayClientTlsCertificate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayClientTlsCertificate = VirtualGatewayClientTlsCertificate;
class VirtualGatewayListenerTlsValidationContext {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsValidationContext = VirtualGatewayListenerTlsValidationContext;
class VirtualGatewayListenerTlsFileCertificate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsFileCertificate = VirtualGatewayListenerTlsFileCertificate;
class VirtualGatewayLogging {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayLogging = VirtualGatewayLogging;
class VirtualGatewayListenerTls {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTls = VirtualGatewayListenerTls;
class SubjectAlternativeNameMatchers {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SubjectAlternativeNameMatchers = SubjectAlternativeNameMatchers;
class VirtualGatewayClientPolicy {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayClientPolicy = VirtualGatewayClientPolicy;
class VirtualGatewayTlsValidationContextSdsTrust {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayTlsValidationContextSdsTrust = VirtualGatewayTlsValidationContextSdsTrust;
class VirtualGatewayListener {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListener = VirtualGatewayListener;
class VirtualGatewayPortMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayPortMapping = VirtualGatewayPortMapping;
class VirtualGatewayBackendDefaults {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayBackendDefaults = VirtualGatewayBackendDefaults;
class VirtualGatewayClientPolicyTls {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayClientPolicyTls = VirtualGatewayClientPolicyTls;
class VirtualGatewayAccessLog {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayAccessLog = VirtualGatewayAccessLog;
class VirtualGatewayFileAccessLog {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayFileAccessLog = VirtualGatewayFileAccessLog;
class VirtualGatewayHttpConnectionPool {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayHttpConnectionPool = VirtualGatewayHttpConnectionPool;
class VirtualGatewayHealthCheckPolicy {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayHealthCheckPolicy = VirtualGatewayHealthCheckPolicy;
class VirtualGatewayTlsValidationContextAcmTrust {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayTlsValidationContextAcmTrust = VirtualGatewayTlsValidationContextAcmTrust;
class VirtualGatewayListenerTlsValidationContextTrust {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsValidationContextTrust = VirtualGatewayListenerTlsValidationContextTrust;
class VirtualGatewayListenerTlsSdsCertificate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VirtualGatewayListenerTlsSdsCertificate = VirtualGatewayListenerTlsSdsCertificate;
class VirtualGateway extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::AppMesh::VirtualGateway', properties);
    }
}
exports.default = VirtualGateway;
VirtualGateway.VirtualGatewayTlsValidationContextTrust = VirtualGatewayTlsValidationContextTrust;
VirtualGateway.VirtualGatewayListenerTlsAcmCertificate = VirtualGatewayListenerTlsAcmCertificate;
VirtualGateway.VirtualGatewayTlsValidationContextFileTrust = VirtualGatewayTlsValidationContextFileTrust;
VirtualGateway.VirtualGatewayHttp2ConnectionPool = VirtualGatewayHttp2ConnectionPool;
VirtualGateway.VirtualGatewaySpec = VirtualGatewaySpec;
VirtualGateway.VirtualGatewayTlsValidationContext = VirtualGatewayTlsValidationContext;
VirtualGateway.VirtualGatewayListenerTlsCertificate = VirtualGatewayListenerTlsCertificate;
VirtualGateway.VirtualGatewayGrpcConnectionPool = VirtualGatewayGrpcConnectionPool;
VirtualGateway.VirtualGatewayConnectionPool = VirtualGatewayConnectionPool;
VirtualGateway.SubjectAlternativeNames = SubjectAlternativeNames;
VirtualGateway.VirtualGatewayClientTlsCertificate = VirtualGatewayClientTlsCertificate;
VirtualGateway.VirtualGatewayListenerTlsValidationContext = VirtualGatewayListenerTlsValidationContext;
VirtualGateway.VirtualGatewayListenerTlsFileCertificate = VirtualGatewayListenerTlsFileCertificate;
VirtualGateway.VirtualGatewayLogging = VirtualGatewayLogging;
VirtualGateway.VirtualGatewayListenerTls = VirtualGatewayListenerTls;
VirtualGateway.SubjectAlternativeNameMatchers = SubjectAlternativeNameMatchers;
VirtualGateway.VirtualGatewayClientPolicy = VirtualGatewayClientPolicy;
VirtualGateway.VirtualGatewayTlsValidationContextSdsTrust = VirtualGatewayTlsValidationContextSdsTrust;
VirtualGateway.VirtualGatewayListener = VirtualGatewayListener;
VirtualGateway.VirtualGatewayPortMapping = VirtualGatewayPortMapping;
VirtualGateway.VirtualGatewayBackendDefaults = VirtualGatewayBackendDefaults;
VirtualGateway.VirtualGatewayClientPolicyTls = VirtualGatewayClientPolicyTls;
VirtualGateway.VirtualGatewayAccessLog = VirtualGatewayAccessLog;
VirtualGateway.VirtualGatewayFileAccessLog = VirtualGatewayFileAccessLog;
VirtualGateway.VirtualGatewayHttpConnectionPool = VirtualGatewayHttpConnectionPool;
VirtualGateway.VirtualGatewayHealthCheckPolicy = VirtualGatewayHealthCheckPolicy;
VirtualGateway.VirtualGatewayTlsValidationContextAcmTrust = VirtualGatewayTlsValidationContextAcmTrust;
VirtualGateway.VirtualGatewayListenerTlsValidationContextTrust = VirtualGatewayListenerTlsValidationContextTrust;
VirtualGateway.VirtualGatewayListenerTlsSdsCertificate = VirtualGatewayListenerTlsSdsCertificate;
